import { Box, Typography, Toolbar, Grid, Paper } from '@mui/material';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const GetInvolved = ({ members = [] }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', }}>
            <Navbar/>
            <Toolbar/>
            <Box sx={{width: '90%', mx: 'auto', flex: 1, py: 4, textAlign: 'center'}}>
                <Typography variant="h2" component="h1" gutterBottom>
                    Our Executive Board
                </Typography>
                <Typography variant="body1" sx={{textAlign: 'center'}} gutterBottom>
                    Our board members work hard to make all of our events possible!
                    If you'd like to apply to join, please use the link below.
                </Typography>
                <Typography component='a' target='_blank' href='https://docs.google.com/forms/d/e/1FAIpQLSfrdPzt_Aaqwh0QhhymlYiKSD4sszITR6PwJD55G3vatohV5w/viewform'>Apply Here!</Typography>
                <Grid container spacing={8} columns={15} sx={{paddingTop: 5}}>
                    {members.map((member) => (
                        <Grid size={{ xs: 15, md: 5 }}>
                            <Paper>
                                {member.Photo && (
                                    <Box
                                        component="img"
                                        src={member.Photo}
                                        alt={member.Name}
                                        sx={{
                                            width: '90%',
                                            height: '400px',
                                            objectFit: 'cover',
                                            borderRadius: 1,
                                            mb: 1,
                                            paddingTop: 2
                                        }}
                                    />
                                )}
                                <Typography variant="h6"><strong>{member.Name}</strong></Typography>
                                <Typography>{member.Role}</Typography>
                                <Typography sx={{paddingBottom: 1}}>{member.Major}, {member.Year}</Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>

            </Box>
            <Footer/>
        </Box>
    );
};

export default GetInvolved;
